module.exports = {"navData":[{"key":"homepage","name":"首页","link":"/"},{"key":"aboutme","name":"关于我们","link":"aboutme"},{"key":"enterpriseDynamics","name":"相关案例","link":"enterpriseDynamics"},{"key":"news","name":"新闻中心","link":"news"},{"key":"linkto","name":"联系我们","link":"linkto"},{"key":"career","name":"招贤纳士","link":"career"},{"key":"publicInfoOpen","name":"信息披露","link":"publicInfoOpen"}]}


//////////////////
// WEBPACK FOOTER
// ./src/json/navbar.json
// module id = l3DV
// module chunks = 0